
import React from 'react';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { cn } from '@/lib/utils';

interface MetalSelectorProps {
  metal: 'gold' | 'silver';
  setMetal: (metal: 'gold' | 'silver') => void;
  disabled?: boolean;
}

export function MetalSelector({ metal, setMetal, disabled }: MetalSelectorProps) {
  const handleValueChange = (value: string) => {
    // onValueChange può essere attivato con una stringa vuota se l'utente deseleziona l'opzione corrente.
    // Vogliamo impostare il metallo solo se viene selezionato un valore nuovo e valido.
    if (value && (value === 'gold' || value === 'silver')) {
      console.log(`[MetalSelector] Impostazione del metallo su: '${value}'`);
      setMetal(value);
    }
  };

  return (
    <ToggleGroup
      type="single"
      value={metal}
      onValueChange={handleValueChange}
      className="grid grid-cols-2 w-full"
      disabled={disabled}
    >
      <ToggleGroupItem
        value="gold"
        className={cn(
          'py-3 text-base font-semibold transition-all rounded-r-none',
          'data-[state=on]:bg-gold data-[state=on]:text-gold-foreground data-[state=on]:shadow-inner',
          'data-[state=off]:bg-card data-[state=off]:hover:bg-muted'
        )}
      >
        Oro
      </ToggleGroupItem>
      <ToggleGroupItem
        value="silver"
        className={cn(
          'py-3 text-base font-semibold transition-all rounded-l-none',
          'data-[state=on]:bg-silver data-[state=on]:text-silver-foreground data-[state=on]:shadow-inner',
          'data-[state=off]:bg-card data-[state=off]:hover:bg-muted'
        )}
      >
        Argento
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
